import { taskOrIssueENUM } from "@mctypes/global.types";
import { IIssueApi } from "@schemas/issueSchema";
import { Menu } from "@mantine/core";
import type { CSSProperties } from "react";
import { IconToggle } from "..";
import { usePostProjectByProjectIdIssuesCopyMutation } from "../../../openapi";
import { STANDARD_COLORS } from "../../app/globalConstants";
import { setShowSuccessMessageThunk } from "../../global/globalSlice";
import { useAppDispatch } from "../../hooks";
import { ToastMessagesEnums } from "../../mc-shared/sharedConstants";

const CopyIssueButton: React.FC<{
  issue: IIssueApi;
  taskOrIssue: taskOrIssueENUM;
  className?: string;
  style?: CSSProperties;
}> = ({ issue, taskOrIssue, ...props }) => {
  const projectId = issue?.project;
  const issueId = issue?._id;

  const dispatch = useAppDispatch();

  const [postIssueCopy] = usePostProjectByProjectIdIssuesCopyMutation();

  const copyIssue = async (includeTasks: boolean) => {
    try {
      const response = await postIssueCopy({
        projectId,
        body: {
          issueId,
          includeTasks,
        },
      }).unwrap();

      console.log("✅ Issue copied successfully:", response);
    } catch (error) {
      dispatch(setShowSuccessMessageThunk(ToastMessagesEnums.COPY_FAILED));
      console.error(error);
    }
  };

  return (
    <div className={props.className ?? "dropdown-row-end"} style={props.style}>
      <Menu position="bottom-end" withArrow>
        <Menu.Target>
          <span>
            <IconToggle
              activeIcon="files-o"
              inactiveIcon="files-o"
              toggled={false}
              activeColor={STANDARD_COLORS.orange}
              onClick={() => {}}
            />
          </span>
        </Menu.Target>
        <Menu.Dropdown>
          {taskOrIssue === "ISSUE" ? (
            <>
              <Menu.Item onClick={() => copyIssue(true)}>Lag kopi med aksjoner</Menu.Item>
              <Menu.Item onClick={() => copyIssue(false)}>Lag kopi uten aksjoner</Menu.Item>
            </>
          ) : (
            <Menu.Item onClick={() => copyIssue(false)}>Lag kopi</Menu.Item>
          )}
        </Menu.Dropdown>
      </Menu>
    </div>
  );
};
export default CopyIssueButton;
